<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员</el-breadcrumb-item>
        <el-breadcrumb-item>会员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium" >
        <el-form-item>
          <el-button type="primary"  size="small"  class="el-icon-circle-plus-outline" v-on:click="AddMember" >新增</el-button>
        </el-form-item>         
        <el-form-item >
          <el-input  placeholder="名称"  size="small" v-model="queryParam.name"  clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  size="small" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="members" style="width: 100%">
        <el-table-column  prop="Number" fixed="left" label="会员号"> </el-table-column>
        <el-table-column  prop="ImageUrl" label="图标" width="80" align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.ImageUrl"
              placement="right"
              trigger="hover"
            >
              <div>
                <img
                  :src="scope.row.ImageUrl"
                  max-width="400"
                  max-height="400"
                >
              </div>  
              <img
                slot="reference"
                :src="scope.row.ImageUrl"
                width="20"
                height="20"
              >
            </el-popover> 
            <p v-else>
              --
            </p>
          </template>         
        </el-table-column>
        <el-table-column  prop="Name"  label="姓名"> </el-table-column>
        <el-table-column  prop="Mobile" width="120px" label="手机号"> </el-table-column>        
        <el-table-column  prop="VipExpiresTime"  label="VIP" :formatter="VipFormat"> </el-table-column>
        <el-table-column  prop="StoreName"  label="归属门店"> </el-table-column>  
        <el-table-column  prop="Gender" width="70px" label="性别" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.Gender=='1'">男</p>
            <p v-if="scope.row.Gender=='2'">女</p>         
          </template>
        </el-table-column>
        <el-table-column  prop="AvailablePoint" width="70px"  label="积分"> </el-table-column>
        <el-table-column  prop="AvailableReward" width="70px"  label="奖励金"> </el-table-column>        
        <el-table-column  prop="RegisterTime"  label="注册时间" :formatter="dateFormat"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="deleteRow(scope.row.Id)" type="text" size="small">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        members:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' RegisterTime desc ',
        },
        ws: null,//建立的连接
        lockReconnect: false,//是否真正建立连接
        timeout: 28*1000,//30秒一次心跳
        timeoutObj: null,//心跳心跳倒计时
        serverTimeoutObj: null,//心跳倒计时
        timeoutnum: null,//断开 重连倒计时
      }
    },
    computed:{
    },
    mounted(){
      this.MembersQuery();
      // this.initWebpack();
      // this.start();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.MembersQuery();
      },
      AddMember:function(){
        this.$router.push({
          name:'memberRegister'
        })
      },
      MembersQuery:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Member/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.members = resp.data.members
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      VipFormat:function(row, column, cellValue, index){
        let data = row[column.property]
        if(data==null){
         return '否'
        }
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },  
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]        
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },      
      deleteRow(id) {
        this.$confirm('确定要删除该会员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Member/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetDate();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetDate()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetDate()
      },
      initWebpack(){
       // let wsurl = 'ws://139.224.80.196:37000';
        let wsurl="ws://zhsq.chenyingwei.com/notifications";
        this.ws = new WebSocket(wsurl);
        this.ws.onopen = this.onopen;
        this.ws.onmessage = this.onmessage;
      // this.ws.onclose = this.onclose;
        this.ws.onerror = this.onerror;
      },
      reconnect() {//重新连接
        var that = this;
        if(that.lockReconnect) {
          return;
        }
        console.log("reconnect")
        that.lockReconnect = true
        //没连接上会一直重连，设置延迟避免请求过多
        that.timeoutnum && clearTimeout(that.timeoutnum);
        that.timeoutnum = setTimeout(function () {
          //新连接
          that.initWebpack();
          that.lockReconnect = false;
        },5000);
      },
      reset(){//重置心跳
        var that = this;
        //清除时间
        clearTimeout(that.timeoutObj);
        clearTimeout(that.serverTimeoutObj);
        //重启心跳
        that.start();
      },
      start(){//开启心跳
        var self = this;
        self.timeoutObj && clearTimeout(self.timeoutObj);
        self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
        self.timeoutObj = setTimeout(function(){
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          if (self.ws.readyState == 1) {//如果连接正常
            self.ws.send("heartCheck");
          }else{//否则重连
            self.reconnect();
          }
          self.serverTimeoutObj = setTimeout(function() {
            //超时关闭
            self.ws.close();
          }, self.timeout);

        }, self.timeout)
      },  
      onopen() {
        var data={
          account:'666666',
          password:'E10ADC3949BA59ABBE56E057F20F883E',
          rsa_key:'strLoginRetPublicKey'
        }
        var msg =""+ JSON.stringify(data);
        this.ws.send(msg);
        console.log("open:"+ msg);
      // this.getNoReadRecords();
        //开启心跳
        this.start();
      },
      onmessage(e) {
        console.log("onmessage："+e.data);
        // this.mydata = JSON.parse(e.data);
        // if(this.mydata.fromID == this.states.customerId){
        //   this.mydata.chatType = 2;
        // }else{
        //   this.mydata.chatType = 1;
        // }
        // var content =this.getContentTypes(this.mydata.content,this.mydata.chatType);
        // console.log(content)
        // this.records.push(this.mydata);
        //收到服务器信息，心跳重置
        this.reset();
      },
      onclose(e) {
        console.log("连接关闭");
        console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean);
      // var msg = JSON.stringify({cmd: 'out_chatting', token:this.COOKIE.getCookie("token")});
    
        //重连
        this.reconnect();
      },
      onerror(e) {
        console.log("出现错误"+e);
        //重连
        this.reconnect();
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>